__turbopack_context__.v({
  "klarnaInfoContainer": "klarna-module-scss-module__CsGqWW__klarnaInfoContainer",
});
